/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: text.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateTextRequest,
  CreateTextResponse,
  GetTextRequest,
  GetTextResponse,
  GetTextsRequest,
  GetTextsResponse,
  UpdateTextRequest,
  UpdateTextResponse,
} from '../types/text';

export const createTextService = (transport: Transport) => ({
  async createText(
    request: CreateTextRequest,
    options: RequestOptions = {},
  ): Promise<CreateTextResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.TextService.CreateText, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<CreateTextResponse>(url, body, options);
  },

  async updateText(
    request: UpdateTextRequest,
    options: RequestOptions = {},
  ): Promise<UpdateTextResponse> {
    const { organization_id, program_id, case_record_id, text_id, ...body } = request;
    const url = getApiPath(API_METHODS.TextService.UpdateText, {
      organization_id,
      program_id,
      case_record_id,
      text_id,
    });
    return transport.post<UpdateTextResponse>(url, body, options);
  },

  async getText(request: GetTextRequest, options: RequestOptions = {}): Promise<GetTextResponse> {
    const { organization_id, program_id, case_record_id, text_id } = request;
    const url = getApiPath(API_METHODS.TextService.GetText, {
      organization_id,
      program_id,
      case_record_id,
      text_id,
    });
    return transport.get<GetTextResponse>(url, options);
  },

  async getTexts(
    request: GetTextsRequest,
    options: RequestOptions = {},
  ): Promise<GetTextsResponse> {
    const { organization_id, program_id, case_record_id, ...params } = request;
    const url = getApiPath(API_METHODS.TextService.GetTexts, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.get<GetTextsResponse>(url, { params, ...options });
  },
});

export type TextService = ReturnType<typeof createTextService>;
